import { IScaffoldActionRowEnterComplete, ScaffoldState } from "./interface";

/**
 * Handles the ROW_ENTER_COMPLETE action by removing the specified row id from
 * the enteringRowIds set once its entry animation has finished.
 * Returns the unchanged state if the row id is not present in the set.
 *
 * @param action - The ROW_ENTER_COMPLETE action carrying the id of the row that finished animating in.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the completed entering row removed from enteringRowIds,
 *          or the unchanged state if the id was not present.
 */
export const scr_rowEnterComplete = <T>(
  action: IScaffoldActionRowEnterComplete,
  state: ScaffoldState<T>,
): ScaffoldState<T> => {
  if (!state.enteringRowIds.has(action.rowId)) {
    return state;
  }

  const next = new Set(state.enteringRowIds);
  next.delete(action.rowId);
  return { ...state, enteringRowIds: next };
};
